module.exports = ".fab-icon {\n  position: relative;\n  font-size: 2em;\n  top: -4px;\n  right: 2px;\n  -webkit-font-feature-settings: \"liga\";\n          font-feature-settings: \"liga\"; }\n\n.fab-disabled {\n  background-color: rgba(195, 195, 195, 0.85) !important;\n  color: rgba(255, 255, 255, 0.54) !important; }\n\n.custom-fab-raised-button .fab-icon {\n  top: -2px; }\n\n.custom-fab-raised-button .fab-text {\n  margin-left: 5px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/widgets/custom-fab/custom-fab.component.scss
// module id = ./src/app/widgets/custom-fab/custom-fab.component.scss
// module chunks = main